/**
 * Styled Components - Created by cazarez on 01/03/18.
 */
import Icon from 'antd/lib/icon'
import Menu from 'antd/lib/menu'
import styled from 'styled-components'
import {
  GRAY_DARK,
  RED_TRANSPARENT,
  WHITE,
  BLUE,
  GRAY_MEDIUM
} from '../../theme/colors'

interface DivProps {
  index?: number
  secondary?: boolean
  cursor?: string
  marginLeft?: string
  marginRight?: string
  color?: string
  fontSize?: string
  order?: number
  designLabView?: boolean
}

export const Container = styled.div``

export const Text = styled.div`
  color: #5f6062;
  &:hover {
    cursor: pointer;
  }
`

interface HeadRowProps {
  withoutPadding?: boolean
}

interface ButtonProps {
  secondary?: boolean
  maxMargin?: boolean
}

export const HeadRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: ${({ withoutPadding }: HeadRowProps) =>
    withoutPadding ? '0' : '0 2% 0 5%;'};

  @media (min-width: 320px) and (max-width: 480px) {
    padding: 0;
  }
`

export const TotalItems = styled.div`
  height: 23px;
  color: #5f6062;
  font-size: 16px;
  line-height: 23px;
`

export const SortOptions = styled.div`
  display: flex;
  align-items: center;
`
export const SortByLabel = styled.div`
  height: 22px;
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-right: 5px;
`
export const StyledImg = styled.img`
  margin-left: 5px !important;
`

export const ThumbnailsList = styled.ul`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ${({ withoutPadding }: HeadRowProps) =>
    withoutPadding ? 'padding: 0px;' : ''};
  width: 100%;
  padding-left: ${({ designLabView }: DivProps) => (designLabView ? '0px' : 'auto')};
  @media (min-width: 768px) and (max-width: 1024px) {
    padding: 0;
  }

  @media (min-width: 320px) and (max-width: 767px) {
    padding: 0;
    gap: 12px;
    justify-content: center;
  }

  @media (min-width: 2024px) {
    justify-content: ${({ designLabView }: DivProps) => (designLabView ? 'flex-start' : 'none')};
  }
`

export const ThumbnailListItem = styled.li`
  list-style: none;
  width: ${({ designLabView }: DivProps) => (designLabView ? 'fit-content' : 'calc(95% / 2)')};
  order: ${({ order }: DivProps) => order || 'unset'};
  animation: scale-in-center 0.1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 
    ${({ index }: DivProps) => `${index ? (index * 0.1) : '1'}s`} both;
  @keyframes scale-in-center {
    0% {
      transform: scale(0.95);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  @media (min-width: 481px) {
    justify-content: center;
    width: 50%;
  }

  @media (min-width: 698px) {
    width: calc(100% / 3);
  }

  @media (min-width: 769px) {
    width: 50%;
  }

  @media (min-width: 990px) {
    padding-bottom: 20px;
    width: 33%;
  }

  @media (min-width: 1260px) {
    width: 25%;
  }

  @media (min-width: 2024px) {
    width: 15%;
  }
  ${({ designLabView }: DivProps) => designLabView ? `
    justify-content: center;
    display: flex;
    margin-right: 10px;
    width: 100% !important;
    &:last-child {
      margin-right: 0px;
    }
    @media (min-width: 481px) {
      justify-content: center;
      max-width: 206px;
    }
    @media (min-width: 698px) {
      max-width: 206px;
    }
    @media (min-width: 769px) {
      max-width: 206px;
    }
    @media (min-width: 990px) {
      padding-bottom: 20px;
      max-width: 150px;
    }
    @media (min-width: 1260px) {
      max-width: 176px;
    }
    @media (min-width: 1440px) {
      max-width: 176px;
      margin-right: 30px;
    }
    @media (min-width: 1768px) {
      max-width: 160px;
      margin-right: 20px;
    }
    @media (min-width: 2024px) {
      margin-right: 24px;
      max-width: 214px;
    }
  ` : ''}
`

export const Loading = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
`
export const PaginationRow = styled.div`
  text-align: right;
  padding-right: 2%;

  @media (min-width: 320px) and (max-width: 480px) {
    padding: 0;
    text-align: center;
  }
`

export const MenuStyle = {
  width: '200px'
}

export const NoResultsFound = styled.div`
  display: flex;
  height: 60vh;
  justify-content: center;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  max-width: 148px;
  width: 100%;
`

export const ButtonContainer = styled.div`
  user-select: none;
  display: flex !important;
  align-items: center;
  margin: ${({ maxMargin }: ButtonProps) => (maxMargin ? '8px 0' : '4px 0')};
  width: 100%;
`

export const ActionButton = styled.div`
  user-select: none;
  background-color: ${({ secondary }: ButtonProps) =>
    secondary ? RED_TRANSPARENT : '#fffffff0'};
  color: ${({ secondary }: ButtonProps) => (secondary ? WHITE : GRAY_DARK)};
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 6px 16px;
  width: 100%;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    filter: brightness(1.1);
  }
`

export const ActionButtonMiddle = styled.div`
  user-select: none;
  background-color: ${({ secondary }: ButtonProps) =>
    secondary ? '#f6d35fe6' : '#79b968d9'};
  color: ${({ secondary }: ButtonProps) => (!secondary ? WHITE : GRAY_DARK)};
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 6px 16px;
  width: 100%;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    filter: brightness(1.1);
  }
`

export const CopyButton = styled.div`
  user-select: none;
  background-color: #000000a3;
  color: ${WHITE};
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 6px 16px;
  width: 100%;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background-color: #000000e3;
  }
`

export const AddNewDesign = styled.div`
  border: 1px dashed ${BLUE};
  height: 221px;
  margin-top: 4px;
  margin-right: 41px;
  max-width: 204px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  border-radius: 3px;
  color: ${BLUE};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: #f2f8ff;
  }
  animation: scale-in-center 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s both;
  @keyframes scale-in-center {
    0% {
      transform: scale(0.75);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  ${({ secondary }: DivProps) => secondary ? `
    margin: 0 auto;
    margin-top: -78px;
  ` : `
    @media (max-width: 768px) {
      margin-right: 30px;
    }
    @media (max-width: 720px) {
      margin-right: 20px;
    }
    @media (max-width: 440px) {
      height: 202px;
      max-width: 198px;
    }
    @media (max-width: 440px) {
      max-width: 174px;
    }
    @media (max-width: 386px) {
      max-width: 164px;
    }
    @media (max-width: 368px) {
      max-width: 154px;
    }
  `}
`

export const PlusSign = styled.div`
  font-weight: bold;
  margin-bottom: 17px;
  font-size: 18px;
`

export const NewLabel = styled.div`
  font-size: 16px;
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const WarningIcon = styled(Icon)``

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
  `

export const StyledMenu = styled(Menu)`
  box-shadow: 0 2px 8px #00000063;
  font-family: Avenir;
  width: 250px;

  .ant-dropdown-menu-item .anticon:first-child {
    margin-right: 10px;
  }

  .ant-dropdown-menu-submenu-title > .anticon:first-child {
    margin-right: 10px;
  }

  .ant-dropdown-menu-item {
    line-height: 25px;
    font-size: 14.5px;
    border-top: 1px solid #f3f3f3;   
    &:first-child {
      border-top: none;
    }
  }
`

export const ThreeDIcon = styled.img`
  transition: all .25s;
  max-width: 18px;
  margin-right: 8px;
`

export const StyledIcon = styled(Icon)`
  cursor: ${({ cursor }: DivProps) => (cursor ? cursor : 'unset')};
  margin-left: ${({ marginLeft }: DivProps) => (marginLeft ? marginLeft : '0')};
  color: ${({ color }: DivProps) => (color ? color : 'unset')};
`

export const MenuItem = styled(Menu.Item)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: default; 
  font-size: ${({ fontSize }: DivProps) => fontSize === 'small' ? '12px' : 'unset' };
  &:hover {
    background: none;
  }
`

export const MenuItemText = styled.p`
  font-size: 12px;
  white-space: break-spaces;
  transition: color 0.2s ease-in-out;
  text-align: right;
  margin-bottom: 0;
`

export const MenuItemCurrencyContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-end;
`

export const MenuItemCurrency = styled.span`
  background-color: #7ec1b6;
  color: #FFFFFF;
  margin: 2px 2px;
  padding: 1px 4px;
  border-radius: 8px;
`

export const MenuHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin: 4px 0;
`

export const MenuHeaderTitle = styled.p`
  font-weight: 600;
  font-size: 17px;
  margin: 0;
`

export const MenuHeaderText = styled.p`
  font-size: 12px;
  margin-bottom: 6px;
  white-space: break-spaces;
`

export const Divider = styled.div`
  height: 1px;
  background-color: #f3f3f3;
`

export const MenuHeaderImportedLabel = styled.p`
  font-size: 12px;
  margin: 0;
  color: ${GRAY_MEDIUM};
  white-space: break-spaces;
  line-height: initial;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductCatalogueThumbnailsList/styledComponents.tsx